enum FilterDateType {
    Absolute = 'absolute',
    Relative = 'relative',
}

export default FilterDateType;
